import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import InviteColleagues from '../common/InviteColleagues';
import { postRequest, deleteRequest } from '../../requestUtils';
import './ProjectPermissions.scss';
var ProjectPermissions = /*#__PURE__*/function (_Component) {
  function ProjectPermissions(props) {
    var _this;
    _classCallCheck(this, ProjectPermissions);
    _this = _callSuper(this, ProjectPermissions, [props]);
    _this.state = {
      invitedColleagues: props.invitedColleagues
    };
    _this.handleAddColleagues = _this.handleAddColleagues.bind(_this);
    return _this;
  }
  _inherits(ProjectPermissions, _Component);
  return _createClass(ProjectPermissions, [{
    key: "handleAddColleagues",
    value: function handleAddColleagues(addFeedbacks) {
      var updatedInvitedColleagues = addFeedbacks.team_members;
      this.setState({
        invitedColleagues: updatedInvitedColleagues
      });
    }
  }, {
    key: "handleSendReminder",
    value: function handleSendReminder(id, email, event) {
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        projectResourceId = _this$props.projectResourceId;
      var target = event.target;
      postRequest("/projects/".concat(projectResourceId, "/project_permissions/").concat(id, "/reminder"), {
        email: email
      }, csrfToken).then(function () {
        target.replaceWith(' Sent!');
      });
    }
  }, {
    key: "handleDelete",
    value: function handleDelete(id) {
      var _this2 = this;
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        projectResourceId = _this$props2.projectResourceId;
      deleteRequest("/projects/".concat(projectResourceId, "/project_permissions/").concat(id), csrfToken).then(function () {
        var invitedColleagues = _this2.state.invitedColleagues;
        var index = invitedColleagues.findIndex(function (elem) {
          return elem.permissions_object_id === id;
        });
        _this2.setState({
          invitedColleagues: update(invitedColleagues, {
            $splice: [[index, 1]]
          })
        });
      });
    }
  }, {
    key: "renderInvitedColleague",
    value: function renderInvitedColleague(id, name, email, level) {
      var _this3 = this;
      return /*#__PURE__*/React.createElement("div", {
        className: "invited-colleague body-text-2",
        key: "invited-".concat(email)
      }, /*#__PURE__*/React.createElement("div", {
        className: "medium-weight mb-2"
      }, name || email), /*#__PURE__*/React.createElement("div", {
        className: "muted-gray-text"
      }, name ? email : 'Pending', !name && /*#__PURE__*/React.createElement("a", {
        tabIndex: 0,
        role: "button",
        className: "ms-2",
        onClick: function onClick(e) {
          return _this3.handleSendReminder(id, email, e);
        }
      }, "Send reminder"), id && level !== 'owner' && /*#__PURE__*/React.createElement("a", {
        tabIndex: 0,
        role: "button",
        className: "ms-2",
        onClick: function onClick() {
          return _this3.handleDelete(id);
        }
      }, "Remove")));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props3 = this.props,
        csrfToken = _this$props3.csrfToken,
        resource = _this$props3.resource,
        inviteUrl = _this$props3.inviteUrl;
      var invitedColleagues = this.state.invitedColleagues;
      return /*#__PURE__*/React.createElement("div", {
        className: "project-permissions"
      }, /*#__PURE__*/React.createElement("div", {
        className: "project-permissions-members"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-users"
      }), invitedColleagues.length, ' ', "member", invitedColleagues.length === 1 ? '' : 's'), /*#__PURE__*/React.createElement(InviteColleagues, {
        location: "invoice View",
        invitedColleagues: invitedColleagues,
        uninvitedColleagues: [],
        csrfToken: csrfToken,
        resource: resource,
        inviteUrl: inviteUrl,
        handleFeedbacks: this.handleAddColleagues,
        header: "Invite new members",
        subtext: "All members can view, export, approve and request changes on the timesheets of this project.",
        messageHeader: "Message",
        ownerMessagePlaceholder: "Write a message to your colleagues",
        cta: "Invite",
        submitCta: "Send",
        showOwnerMessage: true,
        modalClassName: "project-permissions-modal",
        preventCloseModalAfterSubmit: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "colleagues style-guide"
      }, /*#__PURE__*/React.createElement("h2", null, "Members"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mt-3 mb-3"
      }, "1 person must approve project timesheets within 5 days after the consultant submission."), /*#__PURE__*/React.createElement("div", {
        className: "invited-colleagues"
      }, invitedColleagues.map(function (colleague) {
        return _this4.renderInvitedColleague(colleague.permissions_object_id, colleague.name, colleague.email, colleague.permissions_level);
      })))));
    }
  }]);
}(Component);
ProjectPermissions.propTypes = {
  projectResourceId: PropTypes.string.isRequired,
  csrfToken: PropTypes.string,
  resource: PropTypes.string.isRequired,
  invitedColleagues: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  inviteUrl: PropTypes.string.isRequired
};
ProjectPermissions.defaultProps = {
  csrfToken: ''
};
export default ProjectPermissions;